import styled, { css } from 'styled-components'

export const Main = styled.div`
  height: 100%;
  position: absolute;
  margin-left: 25vw;
  width: 73vw;
  margin-top: 0;

  @media (max-width: 800px) {
    width: 100%;
    margin-left: 0;
    margin-top: 70px;
    z-index: 10;
    height: auto;
  }
`

export const Aside = styled.div`
  position: fixed;
  height: 100vh;
  width: 25vw;
  max-width: 300px;

  @media (max-width: 800px) {
    display: none;
    max-width: 100%;

    ${props =>
      props.className === 'closed' &&
      css`
        display: none;
      `}

    ${props =>
      props.className === 'open' &&
      css`
        display: block;
        width: 100vw;
        height: 100%;
        margin-top: 60px;
        z-index: 20;
      `}
  }
`

export const Page = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-height: 100%;
`
